const assetPrefix = '/static/hitch/';
const apiPrefix = '/api';

module.exports = {
  assetPrefix,
  apiPrefix,
};
